import { useState, useEffect } from 'react';

/**
 * SSR 호환 미디어 쿼리 훅
 * 서버사이드 렌더링과 클라이언트 사이드 모두에서 작동하는 미디어 쿼리 훅
 * 
 * @param {string} query - CSS 미디어 쿼리 문자열 (예: '(max-width: 767px)')
 * @param {boolean} defaultValue - SSR 시 사용할 기본값 (선택사항)
 * @returns {boolean} 미디어 쿼리 일치 여부
 */
const useMediaQuery = (query, defaultValue = false) => {
  // Hydration mismatch 방지를 위해 초기값은 항상 defaultValue 사용
  const [matches, setMatches] = useState(defaultValue);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const mediaQuery = window.matchMedia(query);
    
    // 마운트 시점의 값으로 업데이트
    setMatches(mediaQuery.matches);

    const handleChange = (event) => {
      setMatches(event.matches);
    };

    // 최신 브라우저는 addEventListener를 지원하므로 우선 사용
    // 구형 브라우저(Safari < 14) 호환성을 위해 addListener 체크 가능하나,
    // 현재 프로젝트 브라우저 지원 범위 확인 후 addEventListener 사용
    if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', handleChange);
    } else {
        mediaQuery.addListener(handleChange);
    }

    return () => {
        if (mediaQuery.removeEventListener) {
            mediaQuery.removeEventListener('change', handleChange);
        } else {
            mediaQuery.removeListener(handleChange);
        }
    };
  }, [query]);

  return matches;
};

export default useMediaQuery;
